// Booking times are UK wall-clock times at the property, whatever timezone the
// operator's browser is in. These turn a picked date + time into the real
// instant, with the Europe/London offset that applies on that day.
const UK_PARTS = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/London', hourCycle: 'h23',
  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
});

function ukOffsetMinutes(instantMs) {
  const p = Object.fromEntries(UK_PARTS.formatToParts(new Date(instantMs)).map(x => [x.type, x.value]));
  const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute);
  return Math.round((asUtc - Math.floor(instantMs / 60000) * 60000) / 60000);
}

function pad(n) { return String(n).padStart(2, '0'); }

// "2026-06-18", "09:00" -> "2026-06-18T09:00:00+01:00"
export function ukIso(date, time) {
  const wallMs = Date.parse(`${date}T${time}:00Z`);
  let off = ukOffsetMinutes(wallMs);
  off = ukOffsetMinutes(wallMs - off * 60000);
  const sign = off < 0 ? '-' : '+';
  const a = Math.abs(off);
  return `${date}T${time}:00${sign}${pad(Math.floor(a / 60))}:${pad(a % 60)}`;
}

// UK wall-clock start + duration -> { start, end } ISO strings with UK offsets.
export function ukWindowIso(date, time, durationMinutes) {
  const endWall = new Date(Date.parse(`${date}T${time}:00Z`) + durationMinutes * 60000);
  const endDate = `${endWall.getUTCFullYear()}-${pad(endWall.getUTCMonth() + 1)}-${pad(endWall.getUTCDate())}`;
  const endTime = `${pad(endWall.getUTCHours())}:${pad(endWall.getUTCMinutes())}`;
  return { start: ukIso(date, time), end: ukIso(endDate, endTime) };
}

